<template>
  <app-modal
    v-bind="$attrs"
    ref="modal"
    class="modal-container pa-0"
    content-class="modal-large"
    :title="title"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <div class="modal-body">
        <v-container>
          <v-row>
            <v-col>
              <app-label-group
                label="件名"
                :value="notification.noticeInfoTitle"
              />
            </v-col>
          </v-row>

          <template v-if="noticeType === 'MAINTENANCE'">
            <v-row>
              <v-col>
                <app-label-group
                  label="メンテナンス開始予定日時"
                  :value="
                    $filter.emptyTo(
                      $filter.datetime(notification.maintenanceStartDateTime),
                      '-'
                    )
                  "
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <app-label-group
                  label="メンテナンス終了予定日時"
                  :value="
                    $filter.emptyTo(
                      $filter.datetime(notification.maintenanceEndDateTime),
                      '-'
                    )
                  "
                />
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <v-row>
              <v-col>
                <app-label-group
                  label="掲載開始日"
                  :value="$filter.date(notification.postStartDateTime)"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <app-label-group
                  label="掲載終了日"
                  :value="$filter.date(notification.postEndDateTime)"
                />
              </v-col>
            </v-row>
          </template>

          <v-row>
            <v-col>
              <app-label-group label="本文" />
              <v-card variant="outlined" class="text-card-border">
                <div class="details-area">
                  {{ notification.noticeText }}
                </div>
              </v-card>
            </v-col>
          </v-row>

          <template v-if="noticeType === 'MAINTENANCE'">
            <v-row>
              <v-col>
                <app-label-group
                  label="掲載開始日"
                  :value="$filter.date(notification.postStartDateTime)"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <app-label-group
                  label="掲載終了日"
                  :value="$filter.date(notification.postEndDateTime)"
                />
              </v-col>
            </v-row>
          </template>

          <template v-if="noticeType === 'FAILURE_NOTIFICATION'">
            <v-row>
              <v-col>
                <app-label-group
                  label="障害発生日時"
                  :value="
                    notification.isUnderInvestigation
                      ? '調査中'
                      : $filter.datetime(notification.failureDateTime)
                  "
                />
              </v-col>
            </v-row>

            <v-row v-if="notification.recoveryType === 'UNDECIDED'">
              <v-col>
                <app-label-group
                  label="障害復旧日時"
                  :value="'未定'"
                ></app-label-group>
              </v-col>
            </v-row>

            <v-row v-else-if="notification.recoveryType === 'PROSPECT'">
              <v-col>
                <app-label-group
                  label="障害復旧日時(見込み)"
                  :value="$filter.datetime(notification.recoveryDateTime)"
                />
              </v-col>
            </v-row>

            <v-row v-else-if="noticeType === 'FAILURE_NOTIFICATION'">
              <v-col>
                <app-label-group
                  label="障害復旧日時"
                  :value="$filter.datetime(notification.recoveryDateTime)"
                />
              </v-col>
            </v-row>
          </template>
        </v-container>
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn @click="cancel" variant="outlined" color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { NoticeInfoDetail } from "@/apis/InformationApi";

export default defineComponent({
  name: "NotificationReference",
  props: {
    /** お知らせSEQ 主キー */
    noticeInfoSeq: {
      type: String as PropType<string>,
      required: true,
    },
    /** お知らせ種別 */
    noticeType: {
      type: String as PropType<
        "NOTIFICATION" | "FAILURE_NOTIFICATION" | "MAINTENANCE"
      >,
      required: true,
    },
  },
  data() {
    return {
      notification: {} as NoticeInfoDetail,
      isLoaded: false,
    };
  },
  computed: {
    title(): string {
      if (this.noticeType === "MAINTENANCE") {
        return "メンテナンス";
      } else if (this.noticeType === "FAILURE_NOTIFICATION") {
        return "障害情報";
      } else {
        return "その他お知らせ";
      }
    },
  },
  async mounted() {
    this.notification = await this.$api.information.getNotificationDetail(
      this.noticeInfoSeq
    );
    this.isLoaded = true;
  },
});
</script>

<style lang="scss" scoped>
.details-area {
  max-height: 200px;
  overflow-y: scroll;
  white-space: pre-wrap;
}

.text-card-border {
  border-color: rgba(0, 0, 0, 0.125);
}
</style>
